<script setup lang="ts">
  import { ref } from 'vue';

  import TaskEmailResponseView from '@/components/tasks/TaskEmailResponseView.vue';
  import { useTaskEmailResponseExpose } from '@/composables/useTaskEmailResponseExpose';

  interface Props {
    isCollectionView?: boolean;
  }

  defineProps<Props>();

  const TaskEmailResponseRef = ref();

  defineExpose(useTaskEmailResponseExpose(TaskEmailResponseRef));
</script>

<template>
  <TaskEmailResponseView ref="TaskEmailResponseRef" :is-collection-view="isCollectionView" />
</template>

<style scoped></style>
